import { Marquee, loop } from 'dynamic-marquee';
import { $, $$ } from 'utils/dom';

// Animation from https://github.com/tjenkinson/dynamic-marquee
const banners = $$('.banner');
if (banners.length) {
  banners.forEach(banner => {
    // top animation
    const bannerTop = $('.banner__text--top', banner);
    const bannerTopText = bannerTop.dataset.text;
    const marqueeTop = new Marquee(bannerTop, {
      rate: 100, // 20 pixels/s downwards
      startOnScreen: true, // start on screen
    });

    loop(marqueeTop, [() => bannerTopText]);

    // bottom reverse animation
    const bannerBottom = $('.banner__text--bottom', banner);
    const bannerBottomText = bannerBottom.dataset.text;
    const marqueeBottom = new Marquee(bannerBottom, {
      rate: -100, // 20 pixels/s downwards
      startOnScreen: true, // start on screen
    });
    const marqueeBottomLoopArray = [...Array(50)].map(() => bannerBottomText);
    const marqueeBottomLoopText = marqueeBottomLoopArray.join(' ');

    loop(marqueeBottom, [() => marqueeBottomLoopText]);

    banner.addEventListener('mouseover', event => {
      marqueeTop.setRate(0);
      marqueeBottom.setRate(0);
    });

    banner.addEventListener('mouseleave', event => {
      marqueeTop.setRate(100);
      marqueeBottom.setRate(-100);
    });
  });
}
